import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Contact from '../components/ContactForm';

const Home = () => {
    return (
        <div className="home-container">
            {/* <Header /> */}
            <main>
                <h1 className="prompt-black-italic">Jerome Ronquillo, MSE</h1>
                <p>
                    Software engineer passionate about software applications that help people. 
                    Currently interested in the intersection between software development, cloud computing and AI use cases.
                </p>
            </main>
            {/* <Footer /> */}
        </div>
    );
};

export default Home;